(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('buscador-proyectos', {
            parent: 'app',
            url: '/buscador-proyectos',
            data: {
                authorities: [],
                pageTitle: 'Buscador de proyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/buscador-proyectos.html',
                    controller: 'BuscadorProyectosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
	        	periodos: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.periodos().$promise;
	        	}],
	        	centrosDocentes: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.centrosDocentes().$promise;
	        	}],
	        	programasEducativos: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.programasEducativos().$promise;
	        	}],
            }
        })
        .state('buscador-proyectos-solicitud', {
            parent: 'buscador-proyectos',
            url: '/solicitud/{id}',
            data: {
                authorities: [],
                pageTitle: 'Solicitud de proyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/buscador-proyectos-solicitud.html',
                    controller: 'BuscadorProyectosSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BuscadorProyectos', function($stateParams, BuscadorProyectos) {
                    return BuscadorProyectos.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
    }
})();
